import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'navigation-shortcuts.main.add-item.select-item-type-modal.content.type-selectors.link.title',
		defaultMessage: 'Shortcut',
		description: '',
	},
	titleLink: {
		id: 'navigation-shortcuts.main.add-item.select-item-type-modal.content.type-selectors.link.title-link',
		defaultMessage: 'Link',
		description: 'The message for adding a link (previously referred to as "Shortcut")',
	},
	description: {
		id: 'navigation-shortcuts.main.add-item.select-item-type-modal.content.type-selectors.link.description',
		defaultMessage: 'Add a link to a frequently used resource, like a web page.',
		description: '',
	},
});
